"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleProductSearchObject = exports.mergeBannersInProductArray = exports.removeBrandFilterIfBrandPage = exports.filterProductData = exports.isLinkFilter = exports.isBucketFilter = exports.isRangeFilter = exports.isMultiSelectFilter = exports.getDefaultProductColor = void 0;
const common_types_1 = require("@as-react/common-types");
const general_util_1 = require("./general.util");
const isProductColorAvailable = (color) => {
    return color.availability !== 0;
};
const isProductColorDisplayable = (colour) => {
    return isProductColorAvailable(colour) || colour.alwaysVisible;
};
const getDefaultProductColor = (product) => {
    return product.colours.find(colour => colour.colourId === product.colourId);
};
exports.getDefaultProductColor = getDefaultProductColor;
const isDefaultProductColorAvailable = (product) => {
    const defaultColour = (0, exports.getDefaultProductColor)(product);
    if ((0, general_util_1.isNullOrUndefined)(defaultColour)) {
        return false;
    }
    return isProductColorDisplayable(defaultColour);
};
const isMultiSelectFilter = (filterObject) => filterObject.filterType === common_types_1.MULTISELECT_FILTER;
exports.isMultiSelectFilter = isMultiSelectFilter;
const isRangeFilter = (filterObject) => filterObject.filterType === common_types_1.RANGE_FILTER;
exports.isRangeFilter = isRangeFilter;
const isBucketFilter = (filterObject) => filterObject.filterType === common_types_1.BUCKET_FILTER;
exports.isBucketFilter = isBucketFilter;
const isLinkFilter = (filterObject) => filterObject.filterType === common_types_1.LINK_FILTER;
exports.isLinkFilter = isLinkFilter;
const isNotTheDefaultProductColor = (defaultColour) => {
    return (colour) => colour.colourId !== defaultColour.colourId;
};
const removeInvalidProductColours = (product) => {
    const defaultColour = (0, exports.getDefaultProductColor)(product);
    const filteredColours = product.colours
        .filter(isNotTheDefaultProductColor(defaultColour))
        .filter((colour) => isProductColorDisplayable(colour));
    return Object.assign(Object.assign({}, product), { colours: [defaultColour, ...filteredColours] });
};
const filterProductData = (searchResult) => {
    const filteredSearchItems = searchResult
        .items.filter(product => isDefaultProductColorAvailable(product))
        .map(product => removeInvalidProductColours(product));
    return Object.assign(Object.assign({}, searchResult), { items: filteredSearchItems });
};
exports.filterProductData = filterProductData;
/*
 * Check if default filter is set to Brand
 */
const isDefaultFilterBrand = (filterName) => {
    if ((0, general_util_1.isNullOrUndefined)(filterName)) {
        return false;
    }
    return filterName.includes('brand');
};
/*
 * Check if default filter is set to Brand
 */
const removeBrandFilterIfAny = (productSearchObject) => {
    return productSearchObject.filters.filter((item) => {
        return item.filterOn !== 'brand';
    });
};
/*
 * Check if default filter is set to Brand
 */
const removeBrandFilterIfBrandPage = (filterName, productSearchObject) => {
    if (isDefaultFilterBrand(filterName)) {
        return removeBrandFilterIfAny(productSearchObject);
    }
    return productSearchObject.filters;
};
exports.removeBrandFilterIfBrandPage = removeBrandFilterIfBrandPage;
const mergeBannersInProductArray = (searchResult) => {
    var _a;
    let productBanners = [];
    if (!(0, general_util_1.isNullOrUndefined)(searchResult.items)) {
        productBanners = [...searchResult.items];
    }
    if (!(0, general_util_1.isNullOrUndefined)(searchResult.banners)) {
        (_a = searchResult.banners) === null || _a === void 0 ? void 0 : _a.reverse().forEach((banner) => {
            if (!(0, general_util_1.isNullOrUndefined)(banner.listerPosition) && productBanners.length >= banner.listerPosition) {
                const positionIndex = banner.listerPosition - 1;
                productBanners = [...productBanners.slice(0, positionIndex), banner, ...productBanners.slice(positionIndex)];
            }
        });
    }
    return productBanners;
};
exports.mergeBannersInProductArray = mergeBannersInProductArray;
const handleProductSearchObject = (searchResult, defaultFilter) => {
    const filteredProductSearchObject = (0, exports.filterProductData)(searchResult);
    return Object.assign(Object.assign({}, filteredProductSearchObject), { items: (0, exports.mergeBannersInProductArray)(filteredProductSearchObject), filters: (0, exports.removeBrandFilterIfBrandPage)(defaultFilter, filteredProductSearchObject) });
};
exports.handleProductSearchObject = handleProductSearchObject;
//# sourceMappingURL=productSearch.util.js.map